export default __webpack_public_path__ + "static/media/customer.8780a704.png";